export default __webpack_public_path__ + "static/media/conceptos-clave-1.5c374233.png";